import { LinkPayload } from 'src/types/prismicTypes';

export type ClosedImportantNoticeState = {
  noticeId: string;
  closeTime: number;
  closeMode: string;
};

export type ImportantNoticeState = {
  closedImportantNoticeLocalState: ClosedImportantNoticeState[];
};

export type NoticeItem = {
  uid: string;
  icon: string;
  title: string;
  content: string;
  closeMode: ImportantNoticeCloseMode;
  buttonText?: string;
  showCloseIcon?: boolean;
  link?: LinkPayload;
  linkQueue?: string;
  linkType?: string;
  gaCampaignName?: string;
  gaBannerCategory?: string;
  gaCustomBannerCategory?: string;
  existCtaBtn?: boolean;
};

export enum ImportantNoticeAudience {
  All = 'All',
  UserWithInfo = 'Users With Info',
  UserWithoutInfo = 'Users Without Info',
}

export enum ImportantNoticeCloseMode {
  LoginSession = 'Login Session',
  ThreeDays = '72 Hours',
}
